import { render, staticRenderFns } from "./CertifGradScore.vue?vue&type=template&id=8555484e&scoped=true&"
import script from "./CertifGradScore.vue?vue&type=script&lang=js&"
export * from "./CertifGradScore.vue?vue&type=script&lang=js&"
import style0 from "./CertifGradScore.vue?vue&type=style&index=0&id=8555484e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8555484e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
